<div class="qualify-demo" *ngIf="show" role="dialog" aria-modal="true">
  <div class="qualify-demo__backdrop" (click)="onBackdropClick()"></div>

  <div class="qualify-demo__panel" (click)="$event.stopPropagation()">
    <button class="qualify-demo__close" type="button" (click)="close()">
      Back to app
    </button>

    <div class="qualify-demo__header">
      <div class="qualify-demo__heading">
        <h2><b>{{ title }}</b></h2>
        <ol class="qualify-demo__subtitle">
          <li *ngFor="let item of subtitleItems">{{ item }}</li>
        </ol>
      </div>
    </div>

    <div class="qualify-demo__content">
      <div class="demo-grid">
        <div class="demo-extension">
          <div class="extension-header">
            <div class="extension-title">
              <img
                class="extension-favicon"
                src="favicon.ico"
                alt="convverse.ai"
              />
              <span class="extension-name">convverse.ai extension</span>
            </div>
            <!-- <div class="extension-actions">
              <span class="action-pill">Notes</span>
              <span class="action-pill">Qualify</span>
            </div> -->
          </div>

          <div class="extension-body">
            <div class="question-box">
              <div class="question-title">What is your implementation timeline?</div>
            </div>
            <div class="question-box">
              <div class="question-title">How do you plan to fund this initiative?</div>
            </div>

            <div class="question-box" [class.has-answer]="questionAnswer" [class.just-updated]="questionUpdated">
              <div class="question-title">Who will technically approve the product?</div>
              <div class="question-answer" *ngIf="questionAnswer">
                {{ questionAnswer }}
              </div>
            </div>
          </div>
        </div>

        <div class="demo-meeting">
          <div class="video-grid">
            <div class="video-tile" [class.speaking]="activeSpeaker === 'me'">
              <div class="avatar">SR</div>
              <div class="name-tag">
                You
                <span class="mic-pill" [class.on]="activeSpeaker === 'me'">
                  {{ activeSpeaker === 'me' ? 'mic' : 'mic off' }}
                </span>
              </div>
            </div>
            <div class="video-tile" [class.speaking]="activeSpeaker === 'prospect'">
              <div class="avatar">VP</div>
              <div class="name-tag">
                Prospect
                <span class="mic-pill" [class.on]="activeSpeaker === 'prospect'">
                  {{ activeSpeaker === 'prospect' ? 'mic' : 'mic off' }}
                </span>
              </div>
            </div>
          </div>

          <div class="live-captions">
            <div class="caption-label">{{ captionName }}</div>
            <div class="caption-text" [class.typing]="isTyping">{{ captionText }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
